var map = {
	"./tab-havePay-h.png": "74cf",
	"./tab-havePay-m.png": "856b",
	"./tab-home-h.png": "be39",
	"./tab-home-m.png": "e8b4",
	"./tab-manage-h.png": "148d",
	"./tab-manage-m.png": "a9a0",
	"./tab-order-h.png": "68bf",
	"./tab-order-m.png": "102f",
	"./tab-user-h.png": "32d5",
	"./tab-user-m.png": "3efa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2bb5";